module.exports = __webpack_public_path__ + "img/banner.c0fdfd3f.jpg";